import {action, observable, runInAction} from "mobx";
import {
    createRequestFilters,
    ListProviderPatientsRequest, ProviderCollectionPayment,
    ProviderPatient, ProviderPatientStatement
} from "@enter/core";
import {IFeatures, IItemListing, IItemListingRequest} from "./root.store";
import {appendTo, parseItemListingRequest} from "./util";
import _ from "lodash";
import type {PaymentGenerator} from "./payment.generator";
import type {PatientGenerator} from "./patient.generator";
import type {PatientStatementGenerator} from "./patient-statement.generator";
import {PaymentService} from "./payment.service";
import {PatientService} from "./patient.service";

export class PatientStore {
    @observable public patients: ProviderPatient[] = [];

    private features: IFeatures;
    private patientGenerator: PatientGenerator;
    private patientStatementGenerator?: PatientStatementGenerator;
    private patientService: PatientService = new PatientService();

    constructor(
        features: IFeatures,
        patientGenerator: PatientGenerator,
        patientStatementGenerator?: PatientStatementGenerator,
    ) {
        this.features = features;
        this.patientGenerator = patientGenerator;
        this.patientStatementGenerator = patientStatementGenerator;
    }

    // @action
    // public async loadPatientListing(ilr: IItemListingRequest): Promise<IItemListing<ProviderPatient>> {
    //     const lpgr = ilr2lpgr(ilr);
    //     const listing = await (this.features.isDemo
    //         ? this.patientGenerator.loadPatientListing(lpgr)
    //         : this.patientService.fetchPatientListing(lpgr));
    //     if (!listing) {
    //         throw new Error(`No patients available`);
    //     }
    //     const { items } = listing;
    //     runInAction(() => {
    //         this.patients = appendTo<ProviderPatient>(this.patients, items);
    //     });
    //     return listing;
    // }


    /**
     * Resolve an EMR external id to an ENTER patient id in demo mode.
     *
     * Only meaningful under `features.isDemo` — the real app lets `PatientDetailsRedirect` do its
     * own lookup, which works there because the request is not refused.
     */
    @action
    public async resolvePatientIdByExternalId(externalId: string): Promise<string | undefined> {
        if (!this.features.isDemo) {
            return undefined;
        }
        return this.patientGenerator.resolvePatientIdByExternalId(externalId);
    }

    @action
    public async loadPatientStatement(id: string): Promise<ProviderPatientStatement> {
        // The demo branch here was commented out, so this was the one of Jordan's five surfaces
        // that went straight to the API even for the demo account (FE-60).
        if (this.features.isDemo && this.patientStatementGenerator) {
            return this.patientStatementGenerator.loadPatientStatement(id);
        }
        return this.patientService.fetchPatientStatement(id);
    }
}



// export const ilr2lpgr = (ilr: IItemListingRequest): ListProviderPatientsRequest => {
//     const base = parseItemListingRequest(ilr) as ListProviderPatientsRequest;
//     const filters = createRequestFilters(_.get(ilr, 'filters'), true);
//     return {
//         ...base,
//         ...filters,
//     };
// };